export default __webpack_public_path__ + "static/LogisticsHero-0ad71db4bbf5c703e36b33e02df3489c.png";